var borderRadius = {
  small: 3,
  medium: 5,
  large: 8,
  large2: 12,
  mlarge: 16,
  xlarge: 24,
  huge: 100
};
export default borderRadius;